import Trainerlist from './Trainerlist.jsx';

export default Trainerlist;
